import { Fragment, useEffect, useCallback } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
//import Home from "./Pages/Home";
import NewHome from "./Pages/NewHome";
import About from "./Pages/About";
import Jobs from "./Pages/Jobs";
import Workshop from "./Pages/Workshop";
import Contact from "./Pages/Contact";
import CreateProfile from "./Pages/CreateProfile";
import Login from "./Pages/Login";
//import Header from "./Layout/Nav/Header";
import NewHeader from "./Layout/Nav/NewHeader";
//import Footer from "./Layout/Footer";
import NewFooter from "./Layout/NewFooter";
import Resume from "./Pages/Resume";
import Bookmarked from "./Pages/Bookmarked";
import Notifications from "./Pages/Notifications";
import ManageApplications from "./Pages/ManageApplications";
import JobAlerts from "./Pages/JobAlerts";
import AppliedEvents from "./Pages/AppliedEvents";
import EditProfile from "./Pages/EditProfile";
import JobDetails from "./Pages/JobDetails";
import CompanyDetail from "./Pages/CompanyDetail";
import Logout from "./Pages/Logout";
import BookmarkedEvent from "./Pages/BookmarkedEvent";
import RisePlans from "./Pages/RisePlans";
import Partners from "./Pages/Partners";
import JobSeeker from "./Pages/JobSeeker";

import "./Assets/css/linearicons.css";
import "./Assets/css/font-awesome.min.css";
import "./Assets/css/magnific-popup.css";
import "./Assets/css/nice-select.css";
import "./Assets/css/animate.min.css";
import "./Assets/css/owl.carousel.css";
import "./Assets/css/bootstrap.css";
import "./Assets/css/main.css?v";
import "./Assets/css/template.css?v";

import ProtectedRoutes from "./Utils/ProtectedRoutes";
import { useDispatch } from "react-redux";
import { checkAutoLogin } from "./Services/AuthService";
import Employer from "./Pages/Employer";

function MainLayout() {
  return (
    <Fragment>
      {/* <Header /> */}
      <NewHeader />
      <Outlet />
      {/* <Footer /> */}
      <NewFooter />
    </Fragment>
  );
}

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    checkAutoLogin(dispatch);
  }, [dispatch]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use 'auto' for an instant jump
    });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-indigo-50">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route element={<MainLayout />}>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<NewHome />} />
          <Route path="/employer" element={<Employer />} />
          <Route path="/job-seeker" element={<JobSeeker />} />
          <Route path="/about" element={<About />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/workshop" element={<Workshop />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/create-profile" element={<CreateProfile />} />
          <Route path="/job-detail/:id" element={<JobDetails />} />
          <Route path="/company-detail/:id/:name" element={<CompanyDetail />} />
          <Route path="/rise/:slug" element={<CompanyDetail />} />
          <Route path="/rise-plans" element={<RisePlans />} />
          <Route path="/partners/:id/:name" element={<Partners />} />

          {/* Auth routes  */}
          <Route element={<ProtectedRoutes />}>
            <Route path="/resume" element={<Resume />} />
            <Route path="/bookmarked" element={<Bookmarked />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route
              path="/manage-applications"
              element={<ManageApplications />}
            />
            <Route path="/job-alerts" element={<JobAlerts />} />
            <Route path="/applied-events" element={<AppliedEvents />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/bookmarked-event" element={<BookmarkedEvent />} />
          </Route>
        </Route>
      </Routes>
      <button onClick={scrollToTop} className="bg-indigo-600 text-white font-medium fixed bottom-8 right-8 z-50 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 focus:outline-none"><i className="fas fa-chevron-up"></i></button>
    </div>
  );
}

export default App;
